import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Projects from '../components/sections/Projects';
import SectionDivider from '../components/common/SectionDivider';

const ProjectsPage = () => {
  const theme = useTheme();

  return (
    <Box component="main" sx={{ pt: 10 }}>
      <Container maxWidth="lg" sx={{ py: 2 }}>
        <Typography variant="h2" sx={{ 
          mb: 2, 
          fontWeight: 800, 
          textAlign: 'center',
          color: 'info.main'
        }}>
          Our Projects
        </Typography>
        <Typography variant="h6" sx={{ 
          mb: 3, 
          textAlign: 'center',
          color: 'text.secondary',
          maxWidth: 800,
          mx: 'auto'
        }}>
          Showcasing our expertise through successful mechanical contracting projects across the NY metro area.
        </Typography>
      </Container>
      
      <SectionDivider variant="wave" color="info.main" mt={1} mb={2} />
      
      <Box sx={{ background: `linear-gradient(180deg, ${theme.palette.grey[50]}, rgba(2,136,209,0.05))` }}>
        <Projects />
      </Box>
      
      <SectionDivider variant="line" color="info.main" mt={6} mb={6} />
      
      <Container maxWidth="lg" sx={{ py: 4, textAlign: 'center' }}>
        <Button 
          variant="contained" 
          size="large"
          href="tel:(516) 414-0165"
          sx={{ 
            px: 4, 
            py: 2,
            fontSize: '1.1rem',
            fontWeight: 600
          }}
        >
          Start Your Project
        </Button>
      </Container>
    </Box>
  );
};

export default ProjectsPage;
